/**
 * @file index.tsx
 *
 * @fileoverview Provides a component to link to the another page.
 */

import React from 'react';
import Link from '~/jobiqo/components/Link';
import { PagerProps } from '~/jobiqo/components/Pager';
import { addOrReplaceGETParamItemInUrlString } from '~/jobiqo/components/Search/utils/searchHelpers';

interface PagerLinkProps extends Pick<PagerProps, 'filtersToExclude'> {
  /**
   * Any react node child elements.
   */
  children: React.ReactNode | string;
  /**
   * The page number to link to.
   */
  pageNumber: number;
  /**
   * The current query string object.
   */
  querystring: any;
  /**
   * The current path.
   */
  path: string;
}

export default function PagerLink({
  children,
  path,
  querystring,
  pageNumber,
  filtersToExclude,
  ...props
}: PagerLinkProps) {
  let pagerLink = addOrReplaceGETParamItemInUrlString(
    path,
    'page',
    pageNumber.toString(),
    filtersToExclude,
  );

  const url = {
    path,
    query: { ...querystring, page: pageNumber },
  };

  if (pageNumber === 1) {
    delete url.query.page;
    pagerLink = pagerLink.replace('?page=1', '').replace('&page=1', '');
  }

  return (
    <Link href={url} as={pagerLink} prefetch={false} {...props}>
      {children}
    </Link>
  );
}
